define(['../utils', 'common/searchTypes'], function(utils, searchTypes) {
    var postParamNames = [
        'route', 'geometryList'
    ];

    return function(queryParamsNames, configuration, requestOptions, typeParam, language) {

        function getTypeParam(requestOptions) {
            return typeParam ?
                typeParam : utils.required(requestOptions.type, 'Missing type definition');
        }

        function createPathParams(requestOptions) {
            var pathParams = {};
            if (configuration.queryRequired) {
                pathParams.query = utils.required(requestOptions[configuration.queryFieldName],
                    'Missing ' + configuration.queryFieldName + ' statement');
            } else {
                pathParams.query = '';
            }
            pathParams.type = getTypeParam(requestOptions);
            pathParams.contentType = 'json';
            return pathParams;
        }

        function removePostParams(queryParams) {
            postParamNames.forEach(function(bodyParamName) {
                delete queryParams[bodyParamName];
            });
        }

        function createQueryParams(requestOptions) {
            var queryParams = {};
            utils.extractQueryParams(requestOptions, queryParams, queryParamsNames);
            queryParams.language = utils.or(requestOptions.language, language || 'en-GB');
            removePostParams(queryParams);
            return queryParams;
        }

        function isAlongRouteSearch(typeParam) {
            return searchTypes.searchAlongRoute === typeParam;
        }

        function isGeometrySearch(typeParam) {
            return searchTypes.geometry === typeParam;
        }

        function createPostParams(requestOptions) {
            var postParams = {};
            var typeParam = getTypeParam(requestOptions);

            if (isAlongRouteSearch(typeParam) && 'route' in requestOptions) {
                postParams.route = requestOptions.route;
            } else if (isGeometrySearch(typeParam) && 'geometryList' in requestOptions) {
                postParams.geometryList = requestOptions.geometryList;
            }

            return postParams;
        }

        return {
            pathParams: createPathParams(requestOptions),
            postParams: createPostParams(requestOptions),
            queryParams: createQueryParams(requestOptions)
        };
    };
});



// WEBPACK FOOTER //
// ./rest/search/requestParamsFactory.js